import { useCallback } from 'react';
import { uiAppLogger } from 'apps/sigma2-ui/src/lib/logging';
import { ObservationLocationType } from 'libs/end-to-end/src/observation-upload-type';
import { PayBenchmarkingCompensationUnit } from 'libs/end-to-end/src/pay-benchmarking';
import { CustomVizHookDoVizFn } from 'apps/sigma2-ui/src/lib/custom-viz/types';
import { constructPayBenchmarkingRequest } from 'apps/sigma2-ui/src/lib/custom-viz/construct-pay-benchmarking-request';

export const usePayBenchmarkingOnApplyFilters = ({
  canApplyFilters,
  doViz,
  selectedBenchmark,
  selectedCompensationUnit,
  selectedCurrency,
  selectedDepartment,
  selectedEducationLabel,
  selectedExperience,
  selectedLevel,
  selectedLocation,
  selectedRole,
  organizationId,
  observation,
}: {
  canApplyFilters: boolean;
  doViz: CustomVizHookDoVizFn;
  selectedBenchmark: string | null;
  selectedCompensationUnit: PayBenchmarkingCompensationUnit;
  selectedCurrency: string | null;
  selectedDepartment: string | null;
  selectedEducationLabel: string | null;
  selectedExperience: string | null;
  selectedLevel: string | null;
  selectedLocation: string | null;
  selectedRole: string | null;
  organizationId: string;
  observation: ObservationLocationType;
}) => {
  return useCallback(() => {
    uiAppLogger.info('canApplyFilters', canApplyFilters);
    uiAppLogger.info('Applying Filters');

    if (
      selectedDepartment === null ||
      selectedBenchmark === null ||
      selectedRole === null ||
      selectedLevel === null ||
      selectedLocation === null ||
      selectedCurrency === null
    ) {
      return;
    }

    const customVizRequest = constructPayBenchmarkingRequest({
      benchmark: selectedBenchmark,
      department: selectedDepartment,
      role: selectedRole,
      level: selectedLevel,
      location: selectedLocation,
      experience: selectedExperience,
      education: selectedEducationLabel,
      currency: selectedCurrency,
      compensationUnit: selectedCompensationUnit,
      organizationId,
      observationLocationType: observation,
    });

    doViz(customVizRequest);
  }, [
    canApplyFilters,
    doViz,
    organizationId,
    selectedBenchmark,
    selectedCompensationUnit,
    selectedCurrency,
    selectedDepartment,
    selectedEducationLabel,
    selectedExperience,
    selectedLevel,
    selectedLocation,
    selectedRole,
    observation,
  ]);
};
